import { parse } from 'query-string';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { Button, Col, Row } from 'reactstrap';
import { ActivationConfirmationModal } from '../shared/Modals/ActivationConfirmationModal';
import { CreateConsultantModalWithGlobalContext } from '../shared/Modals/CreateConsultantModal/CreateConsultantModal';
import { CreateProjectModalWithGlobalContext } from '../shared/Modals/CreateProjectModal/CreateProjectModal';
import { DeletedConfirmationModal } from '../shared/Modals/DeletedConfirmationModal';
import { LoginModalWithGlobalContext } from '../shared/Modals/LoginModal';
import { ModalPortal } from '../shared/Modals/ModalPortal';
import { ResetPasswordModal } from '../shared/Modals/ResetPasswordModal';
import { ResetPasswordTokenModalWithGlobalContext } from '../shared/Modals/ResetPasswordTokenModal';
import { SignupConfirmationModalWithGlobalContext } from '../shared/Modals/SignupConfirmationModal';
import { SignupModalWithGlobalContext } from '../shared/Modals/SignupModal';
import { HomeDomain } from './HomeDomain/HomeDomain';
import { HomeOperation } from './HomeOperation/HomeOperation';
import { HomePageFooter } from './HomePageFooter';
import { HomeWhy } from './HomeWhy';

const HomePage: React.SFC<RouteComponentProps> = ({ location }) => {
  const query = parse(location.search);
  const [state, setState] = React.useState({
    activationConfirmationModalIsOpen: !!(query && query.activationToken),
    createConsultantModalIsOpen: false,
    createProjectModalIsOpen: false,
    deletedConfirmationModalIsOpen: !!(query && query.deletedConfirmation),
    loginModalIsOpen: false,
    resetPasswordModalIsOpen: false,
    resetPasswordTokenModalIsOpen: !!(query && query.resetPasswordToken),
    signupConfirmationModalIsOpen: false,
    signupModalIsOpen: false,
  });

  const toggleLoginModal = () =>
    setState({
      activationConfirmationModalIsOpen: false,
      createConsultantModalIsOpen: false,
      createProjectModalIsOpen: false,
      deletedConfirmationModalIsOpen: false,
      loginModalIsOpen: !state.loginModalIsOpen,
      resetPasswordModalIsOpen: false,
      resetPasswordTokenModalIsOpen: false,
      signupConfirmationModalIsOpen: false,
      signupModalIsOpen: false,
    });

  const toggleSignupModal = () =>
    setState({
      activationConfirmationModalIsOpen: false,
      createConsultantModalIsOpen: false,
      createProjectModalIsOpen: false,
      deletedConfirmationModalIsOpen: false,
      loginModalIsOpen: false,
      resetPasswordModalIsOpen: false,
      resetPasswordTokenModalIsOpen: false,
      signupConfirmationModalIsOpen: false,
      signupModalIsOpen: !state.signupModalIsOpen,
    });

  const toggleResetPasswordModal = () =>
    setState({
      activationConfirmationModalIsOpen: false,
      createConsultantModalIsOpen: false,
      createProjectModalIsOpen: false,
      deletedConfirmationModalIsOpen: false,
      loginModalIsOpen: false,
      resetPasswordModalIsOpen: !state.resetPasswordModalIsOpen,
      resetPasswordTokenModalIsOpen: false,
      signupConfirmationModalIsOpen: false,
      signupModalIsOpen: false,
    });

  const toggleResetPasswordTokenModal = () =>
    setState({
      ...state,
      resetPasswordTokenModalIsOpen: !state.resetPasswordTokenModalIsOpen,
    });

  const toggleCreateConsultantModal = () =>
    setState({
      ...state,
      createConsultantModalIsOpen: !state.createConsultantModalIsOpen,
    });

  const toggleCreateProjectModal = () => {
    setState({
      ...state,
      createProjectModalIsOpen: !state.createProjectModalIsOpen,
    });
  };

  const toggleSignupConfirmationModal = () => {
    setState({
      ...state,
      signupConfirmationModalIsOpen: !state.signupConfirmationModalIsOpen,
    });
  };

  const toggleActivationConfirmationModal = () => {
    setState({
      ...state,
      activationConfirmationModalIsOpen: !state.activationConfirmationModalIsOpen,
    });
  };

  const toggleDeletedConfirmationModal = () => {
    setState({
      ...state,
      deletedConfirmationModalIsOpen: !state.deletedConfirmationModalIsOpen,
    });
  };


  return (
    <>
        <Row 
          className='home-cover-bis d-flex justify-content-center align-items-center'
        >
          <Col
            md='4'
            xs='auto'
            className='d-flex flex-column justify-content-around align-items-center text-center h-100 py-5'
            style={{ backgroundColor: 'rgba(27, 94, 166, 0.7)' }}
          >
            <Row className='py-4'>
              <Col xs='auto'>
                <h1 className='text-white'>
                  Gérez vos projets
                  <br />
                  autrement
                </h1>
              </Col>
            </Row>
            <Row className='py-4'>
              <Col xs='auto' claccName= 'pb-sm-5'>
                <p className='text-white' style={{ fontSize: '18px' }}>
                  Vous avez un projet opérationnel ou IT ?<br />
                  Notre communauté de consultants
                  
                  <br/>
                  freelances vous accompagne.
                  <br />
                  Déposez gratuitement votre projet en
                  <br />
                  quelques clics.
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs='auto' className='py-sm-5'>
                <Button
                  className='bg-white text-uppercase text-primary border-0'
                  onClick={toggleCreateProjectModal}
                >
                  Déposez un projet
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
    
      <HomeOperation />
      <HomeDomain />
      <HomeWhy
        toggleCreateConsultantModal={toggleCreateConsultantModal}
        toggleCreateProjectModal={toggleCreateProjectModal}
      />
      <HomePageFooter
        toggleCreateConsultantModal={toggleCreateConsultantModal}
        toggleCreateProjectModal={toggleCreateProjectModal}
        toggleLoginModal={toggleLoginModal}
        toggleSignupModal={toggleSignupModal}
      />
      <ModalPortal>
        <LoginModalWithGlobalContext
          isOpen={state.loginModalIsOpen}
          toggleLoginModal={toggleLoginModal}
          toggleResetPasswordModal={toggleResetPasswordModal}
          toggleSignupModal={toggleSignupModal}
        />
        <SignupModalWithGlobalContext
          isOpen={state.signupModalIsOpen}
          toggleLoginModal={toggleLoginModal}
          toggleSignupModal={toggleSignupModal}
          toggleSignupConfirmationModal={toggleSignupConfirmationModal}
        />
        <ResetPasswordModal
          isOpen={state.resetPasswordModalIsOpen}
          toggleLoginModal={toggleLoginModal}
          toggleResetPasswordModal={toggleResetPasswordModal}
        />
        <CreateProjectModalWithGlobalContext
          isOpen={state.createProjectModalIsOpen}
          toggleCreateProjectModal={toggleCreateProjectModal}
          toggleLoginModal={toggleLoginModal}
          toggleSignupConfirmationModal={toggleSignupConfirmationModal}
        />
        <CreateConsultantModalWithGlobalContext
          isOpen={state.createConsultantModalIsOpen}
          toggleCreateConsultantModal={toggleCreateConsultantModal}
          toggleLoginModal={toggleLoginModal}
          toggleSignupConfirmationModal={toggleSignupConfirmationModal}
        />
        <SignupConfirmationModalWithGlobalContext
          isOpen={state.signupConfirmationModalIsOpen}
          toggleSignupConfirmationModal={toggleSignupConfirmationModal}
        />
        {query && query.activationToken && (
          <ActivationConfirmationModal
            isOpen={state.activationConfirmationModalIsOpen}
            activationToken={query.activationToken as string}
            toggleActivationConfirmationModal={toggleActivationConfirmationModal}
            toggleLoginModal={toggleLoginModal}
          />
        )}
        {query && query.resetPasswordToken && (
          <ResetPasswordTokenModalWithGlobalContext
            isOpen={state.resetPasswordTokenModalIsOpen}
            resetPasswordToken={query.resetPasswordToken as string}
            toggleResetPasswordTokenModal={toggleResetPasswordTokenModal}
            toggleLoginModal={toggleLoginModal}
          />
        )}
        {query && query.deletedConfirmation && (
          <DeletedConfirmationModal
            isOpen={state.deletedConfirmationModalIsOpen}
            toggleDeletedConfirmationModal={toggleDeletedConfirmationModal}
          />
        )}
      </ModalPortal>
    </>
  );
};

export const HomePageWithRouter = withRouter(HomePage);



// WEBPACK FOOTER //
// ./src/components/HomePage/HomePage.tsx